import { render, staticRenderFns } from "./MailItem.vue?vue&type=template&id=061fa876"
import script from "./MailItem.vue?vue&type=script&lang=js"
export * from "./MailItem.vue?vue&type=script&lang=js"
import style0 from "./MailItem.vue?vue&type=style&index=0&id=061fa876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports